$(document).ready(function() {
  setTimeout(function() {
    $('.autoplay').slick({
       dots: false,
       infinite: true,
       speed: 500,
       slidesToShow: 4,
       slidesToScroll: 1,
       autoplay: true,
       autoplaySpeed: 2000,
       arrows: false,
       mobile: true,
       responsive: [
        {
            breakpoint: 959,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 720,
            settings: {
                slidesToShow: 1,
            },
        },
      ],
    });
    // On load for Multi Col Slider
    $('.autoplay-multi-col').on('init', function(event, slick, direction){
      $(this).css('height', 'auto').css('opacity', '1');
    });
    $('.autoplay-multi-col').slick({
      dots: false,
      infinite: true,
      speed: 7000,
      slidesToShow: 2,
      slidesToScroll: 1,
      draggable: false,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      arrows: false,
      mobile: true,
      responsive: [
        {
            breakpoint: 959,
            settings: {
                slidesToShow: 2,
                speed: 6000,
            },
        },
        {
            breakpoint: 720,
            settings: {
                slidesToShow: 1,
                speed: 5000,
            },
        },
      ],
    });
    $('.press-slider__block').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: true,
      speed: 7000,
      autoplay: true,
      autoplaySpeed: 0,
      cssEase: 'linear',
      variableWidth: true,
      arrows: false,
      responsive: [
        {
          breakpoint: 959,
          settings: {
            slidesToShow: 2,
            speed: 6000,
          },
        },
        {
          breakpoint: 720,
          settings: {
            slidesToShow: 1,
            speed: 5000,
          },
        },
      ],
    });
  });
});